<div
  class="widget"
    [ngClass]="{
        'active': isSupporter
    }"
  (click)="openSupporterDialog()"
  >
  @if (isSupporter) {
    <mat-icon class="info">info</mat-icon>
  }
  <mat-icon>{{ isSupporter ? "check_circle" : "cancel" }}</mat-icon>
  <span class="text">{{"profile.widgets.supporter" | translate }}</span>
</div>